import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeContextProps } from '../model/theme.types';
import { THEMES } from '../model/constants';

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const saved = localStorage.getItem('theme') || 'light';
    setTheme(saved);
    document.body.dataset.theme = saved;
  }, []);

  const changeTheme = (id: string) => {
    setTheme(id);
    document.body.dataset.theme = id;
    localStorage.setItem('theme', id);
  };

  const toggleTheme = () => {
    const next = theme === 'light' ? 'second-light' : theme === 'second-light' ? 'dark' : 'light';
    changeTheme(next);
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme, toggleTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext };

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme должен использоваться внутри ThemeProvider');
  return context;
}; 